module.exports = __webpack_public_path__ + "media/images/award-badges-mobile-en-fd9e8580d3a439318d06dc9586642bd8.svg";